export default __webpack_public_path__ + "static/media/quick-online-logo-q.bc54f70f.svg";